import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private nameSource = new BehaviorSubject<string>('');
  currentName = this.nameSource.asObservable();

  constructor() { }

  updateName(name: string) {
    this.nameSource.next(name);
  }
}
